const ADMIN_PRIVATE_WRAPPER = 'private';

export const FEATURE_STORE_KEY = 'car-insurance';

export const MODULE_PATHS_CONSTANTS = {
  // Car Insurance Module
  BASE_ROUTE: 'autos',
  // Car Insurance Coefficients
  CAR_INSURANCE_COEFFICIENTS: 'coeficientes',
  // Car Insurance Coefficients by broker
  CAR_INSURANCE_COEFFICIENTS_BROKERS: 'coeficientes-corredores',
  // Car Insurance Polizas
  CAR_INSURANCE_POLICY: 'polizas',
  // Car Insurance Parameters
  CAR_INSURANCE_PARAMETERS: 'parametros',
  // Car New Model
  CAR_NEW_MODEL: 'modelo',
  // Car Models
  CAR_MODELS: 'modelos',
  // Car Modify Model
  CAR_MODIFY_MODEL: 'modelo/:modelId/:year',
  // Car Packages
  CAR_PACKAGES: 'paquetes',
  // Car New Package
  CAR_NEW_PACKAGE: 'paquete',
  // Car Modify Package
  CAR_MODIFY_PACKAGE: 'paquete/:packageId',
  // Car Coverages
  CAR_COVERAGES: 'coberturas',
  // Car New Coverage
  CAR_NEW_COVERAGE: 'cobertura',
  // Car Modify Coverage
  CAR_MODIFY_COVERAGE: 'cobertura/:coverageId',
  // Car Autodata
  CAR_FILE_UPLOAD: 'autodata',
  // Quotes Audit
  QUOTES_AUDIT: 'auditoria',
  // Quotes Audit Detail
  QUOTES_AUDIT_DETAIL: 'auditoria/:quoteId',
  // Failed Quotes
  FAILED_QUOTES: 'cotizaciones-fallidas',
  // Settings
  SETTINGS_BDEO: 'configuracion-bdeo',
  // Detalle Poliza
  POLICY_DETAIL: 'polizas/detalle/:policyId/:failed',
};

export const generateFullModuleRoute = (route: string): string => {
  return `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}/${route}`;
};

export const fullAppPageRoute = (route: string): string => {
  return `${ADMIN_PRIVATE_WRAPPER}/${generateFullModuleRoute(route)}`;
};

export const MODULE_NAVIGATION_MENU = [
  {
    title: 'Automóviles',
    activated: true,
    collapsed: true,
    collapsable: true,
    navigationItems: [
      {
        icon: 'pi pi-money-bill',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.QUOTES_AUDIT),
        title: 'Cotizaciones',
        activated: true,
      },
      {
        icon: 'pi pi-exclamation-triangle',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.FAILED_QUOTES),
        title: 'Fallidas',
        activated: true,
      },
      {
        icon: 'pi pi-shield',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.CAR_INSURANCE_POLICY
        ),
        title: 'Pólizas',
        activated: true,
      },
      {
        icon: 'pi pi-bars',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.CAR_INSURANCE_COEFFICIENTS
        ),
        title: 'Coeficientes',
        activated: true,
      },
      {
        icon: 'pi pi-bars',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.CAR_INSURANCE_COEFFICIENTS_BROKERS
        ),
        title: 'Coeficientes corredores',
        activated: true,
      },
      {
        icon: 'pi pi-sliders-h',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.CAR_INSURANCE_PARAMETERS
        ),
        title: 'Parámetros',
        activated: true,
      },
      {
        icon: 'pi pi-car',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_MODELS),
        title: 'Vehículos',
        activated: true,
      },
      {
        icon: 'pi pi-list-check',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_COVERAGES),
        title: 'Coberturas',
        activated: true,
      },
      {
        icon: 'pi pi-box',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_PACKAGES),
        title: 'Paquetes',
        activated: true,
      },
      {
        icon: 'pi pi-file-arrow-up',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_FILE_UPLOAD),
        title: 'Carga de datos',
        activated: true,
      },
    ],
  },
];

export const MODULE_ROUTES_NOT_MENU = [
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_NEW_MODEL),
    title: 'Crear Modelo',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_MODELS),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_MODIFY_MODEL),
    title: 'Editar Modelo',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_MODELS),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_NEW_PACKAGE),
    title: 'Crear Paquete',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_PACKAGES),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_MODIFY_PACKAGE),
    title: 'Editar Paquete',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_PACKAGES),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_NEW_COVERAGE),
    title: 'Crear Cobertura',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.CAR_COVERAGES
    ),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.CAR_MODIFY_COVERAGE),
    title: 'Editar Cobertura',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.CAR_COVERAGES
    ),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.POLICY_DETAIL),
    title: 'Volver al listado',
    activateRoute: generateFullModuleRoute(
      MODULE_PATHS_CONSTANTS.CAR_INSURANCE_POLICY
    ),
  },
  {
    icon: 'fas fa-arrow-left',
    route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.QUOTES_AUDIT_DETAIL),
    title: 'Detalle de cotización',
    activateRoute: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.QUOTES_AUDIT),
  },
];

export const CAMPAING_TYPE = {
  PROMOCIONAL: 1,
  AUTOGENERADO: 2,
};

export const QUOTER_ENUM = {
  DIRECT_QUOTER: 1,
  BROKERS_QUOTER: 2,
};

// Inline style for <p-toggleswitch>, matching the app's danger/positive
// palette. Must be set via [style] directly on the component (not on an
// ancestor), because PrimeNG's own theme sets these same CSS variables
// directly on .p-toggleswitch, which otherwise wins over an inherited value.
export const STATUS_TOGGLE_STYLE = {
  '--p-toggleswitch-width': '2.5rem',
  '--p-toggleswitch-height': '1.35rem',
  '--p-toggleswitch-handle-size': '1rem',
  '--p-toggleswitch-background': '#de216b',
  '--p-toggleswitch-hover-background': '#de216b',
  '--p-toggleswitch-checked-background': '#46bfa3',
  '--p-toggleswitch-checked-hover-background': '#46bfa3',
  '--p-toggleswitch-handle-background': '#ffffff',
  '--p-toggleswitch-handle-checked-background': '#ffffff',
  '--p-toggleswitch-handle-hover-background': '#ffffff',
  '--p-toggleswitch-handle-checked-hover-background': '#ffffff',
};

export const LIST_CAR_POLICY_COLUMNS_NAME = {
  ISSUED_DATE: 'issuedDate',
  START_DATE: 'validFromDate',
  END_DATE: 'validToDate',
  INSURED_NAME: 'insuredName',
  ID_NUMBER: 'idNumber',
  ISSUED_STATUS: 'issuedStatus',
  PAYMENT_STATUS: 'paymentStatus',
  POLICY_NUMBER: 'policyNumber',
  STATUS: 'status',
  ORIGIN: 'origen',
  BROKER_NAME: 'brokerName',
  BROKER_CODE: 'brokerCode',
  COVERAGE_PACKAGE: 'coveragePackage',
  CAR_REGISTRATION_NUMBER: 'carRegistrationNumber',
  CAR_MODEL: 'carModel',
  PLAN_TYPE: 'planType',
  ACTIONS: 'actions',
};

export const QUOTES_AUDIT_LIST_COLUMNS_NAME = {
  QUOTE_ID: 'quoteId',
  GENERATION_DATE: 'generationDate',
  BROKER_CARD_NAME: 'brokerCardName',
  POLICY_NUMBER: 'policyNumber',
  CAR_REGISTRATION_NUMBER: 'carRegistrationNumber',
  EMAIL: 'email',
  EMISSION_STATUS: 'emissionStatus',
  PAYMENT_STATUS: 'paymentStatus',
  DOCUMENT_ID: 'documentId',
  REFERENCE_NUMBER: 'referenceNumber',
  BROKER_CARD_CODE: 'brokerCardCode',
  PLAN_TYPE: 'planType',
  QUOTE_OPTIONS: 'quoteOptions',
  ACTIONS: 'actions',
};

export const CONFIG_LISTADO = {
  CAR_POLICY: 'Administrador.Automoviles.ListadoPolizas',
  QUOTES_AUDIT_LIST: 'Administrador.Automoviles.ListadoCotizaciones',
  CAR_COVERAGES: 'Administrador.Automoviles.ListadoCoberturas',
};

export const ISSUED_STATUS = [
  { name: 'Emitida', value: 'Emitida' },
  { name: 'Fallida', value: 'Fallida' },
  { name: 'Procesando', value: 'Procesando' },
  { name: 'Cotizada', value: 'Cotizada' },
];

export const STATUS_ENUM = [
  { name: 'Vigente', value: 'Vigente' },
  { name: 'Cancelada', value: 'Cancelada' },
  { name: 'Expirada', value: 'Expirada' },
];

export const DOCUMENT_TYPES = {
  CI: 'CI',
  RUT: 'RUT',
  EXT: 'EXT',
};

export const IS_RENEWAL = {
  RENOVACION: 'Renovación',
  NUEVA_POLIZA: 'Nueva Póliza',
};

export const DOCUMENT_TYPES_OPTIONS = [
  {
    value: DOCUMENT_TYPES.CI,
    name: DOCUMENT_TYPES.CI,
  },
  {
    value: DOCUMENT_TYPES.RUT,
    name: DOCUMENT_TYPES.RUT,
  },
];

export const ORIGIN_OPTIONS = [
  { name: 'Nueva póliza', value: 0 },
  { name: 'Renovación', value: 1 },
  { name: 'Cambio de vehículo', value: 2 },
];

export const ORIGIN_VALUES = {
  NEW_POLICY: 'Nueva póliza',
  RENEWED: 'Renovación',
  VEHICLE_CHANGE: 'Cambio de vehículo',
};

export const PAYMENT_STATUS = [
  { name: 'Fallido', value: 'Fallido' },
  { name: 'Procesado', value: 'Procesado' },
  { name: 'Enviado', value: 'Enviado' },
];

export const ORIGIN_STATUS = [
  { name: 'Renovación', value: 'Renovación' },
  { name: 'Nueva Póliza', value: 'Nueva Póliza' },
  { name: 'Cambio de vehículo', value: 'Cambio de vehículo' },
];

export const PLAN_TYPE_OPTIONS = [
  { name: 'Plan anual', value: 'Plan anual' },
  { name: 'Auto Ahorro 2.0', value: 'Auto ahorro 2.0' },
  { name: 'Auto Ahorro 3.0', value: 'Auto ahorro 3.0' },
];

export const PLAN_TYPE = {
  ANNUAL: 'Plan anual',
  AUTO_SAVING_2_0: 'Auto ahorro 2.0',
  AUTO_SAVING_3_0: 'Auto ahorro 3.0',
};

export const QUOTE_OPTIONS_OPTIONS = [
  { name: 'Plan anual', value: 'Plan anual' },
  {
    name: 'Plan anual / Auto ahorro 2.0',
    value: 'Plan anual / Auto ahorro 2.0',
  },
  {
    name: 'Plan anual / Auto ahorro 3.0',
    value: 'Plan anual / Auto ahorro 3.0',
  },
  {
    name: 'Plan anual / Auto ahorro 2.0 / Auto ahorro 3.0',
    value: 'Plan anual / Auto ahorro 2.0 / Auto ahorro 3.0',
  },
];

export const POLICY_DETAIL_ERROR_CONSTANTS = {
  ALTA_BP: 'AltaBP',
  ALTA_ORDER: 'AltaOrder',
  PAGO_SAP: 'PagoSAP',
  AJ_ASIENTO: 'AjAsiento',
};
